import { Button, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useRouteMatch } from 'react-router';
import { finalize, init } from '../../components/GlobalFeedback/feedbackSlice';
import { fetchConcursoActivo, tiposSelector } from './Gestion/gestionConcursoSlice';
const PreviewCard = ({ con, onVerMas, footer }) => {
  const tiposConcurso = useSelector(tiposSelector);

  const {
    idLlamadoConcurso,
    titulo,
    idTipoConcurso,
    cantidadCargoReserva,
    cantidadCargoSinReserva,
    nroExpedienteAsignacion,
    nroProda,
  } = con;

  const Footer = TramitarFooter;
  return (
    <Card style={{ marginBottom: 25, width: '20rem' }}>
      <Card.Header>
        <Card.Title>{titulo}</Card.Title>
      </Card.Header>
      <Card.Body>
        <ul className="descConcurso">
          <li>ID: {idLlamadoConcurso}</li>
          <li>
            Convocatoria <b>{tiposConcurso[idTipoConcurso].nombre}</b>
          </li>
          <li
            title={`(${cantidadCargoReserva} con reserva - ${cantidadCargoSinReserva} sin reserva)`}>
            <b>{cantidadCargoReserva + cantidadCargoSinReserva}</b> cargos
          </li>

          <li>
            <b>Exp. Asignación:</b> {nroExpedienteAsignacion || <i>Sin N°</i>}
          </li>
          <li>
            <b>N° PRODA:</b> {nroProda || <i>Sin N°</i>}
          </li>
        </ul>
      </Card.Body>
      <Card.Footer>
        <Footer idConcurso={idLlamadoConcurso} />
      </Card.Footer>
    </Card>
  );
};

const AspiranteFooter = ({ idConcurso }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { path } = useRouteMatch();

  const handlePostularse = () => {
    dispatch(init());
    dispatch(fetchConcursoActivo({ idConcurso })).then(() => {
      dispatch(finalize());
      history.push(`${path}/postularse`);
    });
  };

  return (
    <>
      <Button size="sm" variant="warning" className="float-left" onClick={handlePostularse}>
        <i className="fa fa-check-square-o"></i>&nbsp; Postularse
      </Button>

      {/* <Button size="sm" variant="primary" className="float-right" onClick={() => handleVerMas)}>
        <i className="fa fa-info-circle"></i>&nbsp;
        Ver más
      </Button> */}
    </>
  );
};

const TramitarFooter = ({ idConcurso }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { path } = useRouteMatch();

  // const isAllowedConcurso = useCheckRoles([
  //   ROLES.ADMIN,
  //   ROLES.LEGALES,
  //   ROLES.COMITE,
  //   ROLES.DIRECTOR,
  // ]);
  // const isUser = useCheckRoles([
  //   ROLES.USER,
  //   ROLES.ADMIN,
  //   ROLES.ADMIN,
  //   ROLES.LEGALES,
  //   ROLES.COMITE,
  //   ROLES.DIRECTOR,
  // ]);
  // const isDirector = useCheckRoles([ROLES.DIRECTOR]);
  // const isComite = useCheckRoles([ROLES.COMITE]);
  // const isGuest = useCheckRoles(ROLES.GUEST);

  const handleTramitar = () => {
    dispatch(init());
    dispatch(fetchConcursoActivo({ idConcurso })).then(() => {
      dispatch(finalize());
      history.push(`${path}/tramitar`);
    });
  };

  return (
    <>
      <Button size="sm" variant="warning" className="float-left" onClick={handleTramitar}>
        <i className="fa fa-folder-open"></i>&nbsp; Tramitar
      </Button>
    </>
  );
};

const VeedorFooter = (props) => {
  return (
    <>
      {/* <Button size="sm" variant="warning" className="float-left"onClick={() => handleTramitar(idLlamadoConcurso)} >
        <i className="fa fa-folder-open"></i>&nbsp;
        Tramitar
      </Button>

      <Button size="sm" variant="primary" className="float-right" onClick={() => handleVerMas(idLlamadoConcurso)}>
        <i className="fa fa-info-circle"></i>&nbsp;
        Ver más
      </Button> */}
    </>
  );
};

export default PreviewCard;
